module.exports = __webpack_public_path__ + "img/T954.0a069fda.jpg";